import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-unassign-diaglog',
  templateUrl: './unassign-diaglog.component.html',
  styleUrls: ['./unassign-diaglog.component.scss']
})
export class UnassignDiaglogComponent implements OnInit {
  unassignYes = new EventEmitter<boolean>();
  lessonName: string;
  studentName: string;

  constructor(
    public dialogRef: MatDialogRef<UnassignDiaglogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.lessonName = data.lessonName ?? "All";
    this.studentName = data.studentName ?? "Everyone";
   }

  ngOnInit(): void {
  }

  onUnassign(){
    this.unassignYes.emit(true);
    this.onCancel();
  }

  onCancel(){
    this.dialogRef.close();
  }

}
